import { QuestionData } from '../types';

export const stripUiOnlyFields = (
  questions: QuestionData[],
): Partial<QuestionData>[] => {
  const lastIndex = questions.length - 1;

  return questions.map((q, index) => {
    const {
      isExpanded,
      textTouched,
      descriptionTouched,
      answerTypeTouched,
      databaseFieldTouched,
      hadOtherOption,
      optionsError,
      ...cleaned
    } = q;

    if (cleaned.numericOptions) {
      const { minValueTouched, maxValueTouched, ...rest } =
        cleaned.numericOptions;
      cleaned.numericOptions = rest;
    }

    if (cleaned.translations?.length) {
      cleaned.translations = cleaned.translations.map(
        ({
          uiPublishQuestionTextError: _eqt,
          uiPublishDescriptionError: _eqd,
          uiPublishOptionsError: _eqo,
          ...tr
        }) => tr,
      );
    }

    if (cleaned.options) {
      const isLast = index === lastIndex;
      cleaned.options = cleaned.options.map(({ textError, ...opt }) => ({
        ...opt,
        ...(isLast ? { nextAction: 'submit' } : {}),
        translations: opt.translations?.map(
          ({ uiPublishOptionTextError: _eot, ...otr }) => otr,
        ),
      }));
    }

    return cleaned;
  });
};
